<template>
  <div>
    <v-row v-if="isError">
      <v-col cols="12">
        <v-alert type="error">
          {{ hosting_error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!isError && inactiveService">
      <v-col cols="12" sm="6">
        <service-info />
      </v-col>
      <v-col cols="12" sm="6">
        <hosting-pending :status="hosting.status" />
      </v-col>
    </v-row>
    <v-row v-if="!isError && !inactiveService">
<!--      <v-col cols="12" class="pb-0">-->
<!--        <gg-card-title subtitle>-->
<!--          {{ $route.meta.pageSubtitle }}-->
<!--        </gg-card-title>-->
<!--      </v-col>-->
      <v-col cols="12" class="pt-0">
        <gg-loading :loading="loading" type="image" height="400">
          <router-view :loading="loading"/>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HostingPending from '@/components/Services/Hosting/Common/HostingPending'
import ServiceInfo from '@/components/Services/Hosting/Common/ServiceInfo'
import { launch_cpanel } from '@/helpers/helpers'
import { sharedMenu } from '@/helpers/menu'

export default {
  name: 'SharedService',
  components: {
    ServiceInfo,
    HostingPending,
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    launch_cpanel,
  }),
  computed: {
    ...mapGetters(['hosting', 'hostingPopulated', 'hosting_detail', 'hosting_error']),
    sharedMenu () {
      const menu = sharedMenu(this.$route.query.user)
      if (
        this.$route.query.user &&
        menu[5] &&
        menu[5].items &&
        menu[5].items[5] &&
        menu[5].items[5].name === 'hosting_cpanel_change_primary_domain'
      ) {
        menu[5].items.splice(5, 1)
      }
      return menu
    },
    isError () {
      return this.hosting_error !== null
    },
    hostingid () {
      return this.$route.params.hostingid
    },
    inactiveService () {
      return this.hosting.status === 'Pending' || this.hosting.status === 'Suspended'
    },
    hideNavigation () {
      return this.$route.meta.hideNavigation ?? false
    }
  },
  methods: {
    menuClick (handler, params) {
      if (typeof handler !== 'function') return
      handler(params)
    }
  }
}
</script>
